import React from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';

import styles from './close-section.module.scss';

interface Props {
	sectionName: string;
	openSection(): void;
}

const CloseSection = ({ sectionName, openSection }: Props) => {
	return (
		<div
			className={styles.sectionContainer}
			onClick={openSection}
			data-test-id={`close-section-container-${sectionName}`}
			title={sectionName}
		>
			<Button className={styles.iconsContainer} type="ghost">
				<BringgIcon iconName={BringgFontIcons.ChevronLeft} className={styles.firstIcon} />
				<BringgIcon iconName={BringgFontIcons.ChevronRight} className={styles.secondIcon} />
			</Button>
			<div className={styles.sectionTextContainer}>
				<div className={styles.sectionText}>
					<span>{sectionName}</span>
					<span className={styles.sectionSymbol}>{sectionName.charAt(0)}</span>
				</div>
			</div>
		</div>
	);
};

export default CloseSection;
